import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';

export default function StaffLogin() {
    const navigate = useNavigate();
    const [credentials, setCredentials] = useState({ email: '', password: '' });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const res = await api.post('/login', credentials);

            // Validate role
            if (res.data.user.role !== 'staff' && res.data.user.role !== 'admin') {
                setError('Acceso denegado.');
                setLoading(false);
                return;
            }

            localStorage.setItem('token', res.data.access_token);
            navigate('/staff/scan');
        } catch (err) {
            setError(err.response?.data?.message || 'Error de inicio de sesión');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex justify-center items-center h-[70vh]">
            <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md border-t-8 border-yellow-500">
                <h2 className="text-2xl font-bold mb-6 text-center text-yellow-700">Ingreso Staff</h2>

                {error && <div className="mb-4 text-red-600 bg-red-100 p-3 rounded">{error}</div>}

                <form onSubmit={handleLogin}>
                    <div className="mb-4">
                        <label className="block text-gray-700 font-medium mb-2" htmlFor="email">Email</label>
                        <input
                            required
                            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:border-yellow-500"
                            type="email"
                            id="email"
                            placeholder="staff@test.com"
                            value={credentials.email}
                            onChange={e => setCredentials({ ...credentials, email: e.target.value })}
                        />
                    </div>
                    <div className="mb-6">
                        <label className="block text-gray-700 font-medium mb-2" htmlFor="password">Password</label>
                        <input
                            required
                            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:border-yellow-500"
                            type="password"
                            id="password"
                            placeholder="********"
                            value={credentials.password}
                            onChange={e => setCredentials({ ...credentials, password: e.target.value })}
                        />
                    </div>
                    <button
                        disabled={loading}
                        className={`w-full text-white font-bold py-2 px-4 rounded transition-colors ${loading ? 'bg-gray-400 cursor-not-allowed' : 'bg-yellow-600 hover:bg-yellow-700'}`}
                        type="submit"
                    >
                        {loading ? 'Iniciando sesión...' : 'Ingresar'}
                    </button>
                </form>
            </div>
        </div>
    );
}
